<template>
  <div class="landing-page">
    <LandingPageStepHeader class="landing-page-hero">

      <div class="container">
        <h1 class="landing-page-hero__heading">Easy Payments on a Car You’ll Love</h1>
        <p class="landing-page-hero__subheading">
          Fast, Convenient and Secure.
        </p>
      </div>

      <div class="landing-page-hero__bg-container container">
        <div class="landing-page-hero__bg"/>
      </div>

      <div class="container">

        <div class="landing-page-hero__cta">
          <div class="landing-page-hero__cta-text">Are you interested in $0 down options?</div>
          <div class="landing-page-hero__buttons">
            <AppButtonContinue
              v-for="(button, index) in buttons"
              :key="index"
              v-data-layer
              :data-layer="button.datalayer"
              class="landing-page-hero__button"
              @click="handleClick(button.text)"
            >
              {{ button.text }}
            </AppButtonContinue>
          </div>
        </div>
        <div class="landing-page-hero__tooltip">
          <small>
            We have $0 down options available, making it even easier for you to get the car you want.
          </small>
        </div>
      </div>

    </LandingPageStepHeader>

    <Inventory
      @vehicle-click="handleInventoryClick()"
    />

    <HowItWorks/>

    <GetApprovedCTA
      @cta-click="$emit('next')"
    />
  </div>
</template>

<script>
import AppButtonContinue from '@/components/common/buttons/AppButtonContinue'
import DataLayer from '@/data-layer'
import GetApprovedCTA from './GetApprovedCTA'
import Inventory from './Inventory'
import HowItWorks from './HowItWorks'
import LandingPageStepHeader from './LandingPageStepHeader'

export default {
  name: 'landing-page',

  components: {
    AppButtonContinue,
    GetApprovedCTA,
    Inventory,
    HowItWorks,
    LandingPageStepHeader
  },

  data () {
    return {
      datalayerStepName: 'zero_down',
      selectedDatalayer: '',
      buttons: [{
        text: 'Yes',
        datalayer: 'zero_down_yes'
      }, {
        text: 'No',
        datalayer: 'zero_down_no'
      }]
    }
  },

  computed: {
    datalayerContinue () {
      return `${this.datalayerStepName}_continue`
    },

    datalayerValue () {
      return `${this.datalayerStepName}_${this.datalayerContinue}`
    }

  },

  mounted () {
    this.$store.updateApplication('zero_down', this.buttons[0].text)
  },

  methods: {
    handleClick (value) {
      this.$store.updateApplication('zero_down', value)
      DataLayer.pushEvent('event', this.datalayerContinue)
      this.$emit('next')
    },

    handleInventoryClick () {
      DataLayer.pushEvent('event', this.datalayerContinue)
      DataLayer.pushEvent('event', 'vehicle_type_continue')
      this.$emit('next', 'budget-select')
    }
  }
}
</script>

<style lang="scss" scoped>
$light-blue: #3FF6FE;
$dark-blue: #22C8F9;
$imagePath: '../../../../../assets/img/landing-page/blue-wave-bg/';
.landing-page.step-component {
  padding-top: 0;
}

.landing-page-hero {
  position: relative;
  margin-bottom: 10px;
  top: -105px;
  padding-bottom: 0;

  @include breakpoint('tablet-portrait-up') {
    margin-bottom: 0px;
  }

  @include breakpoint('tablet-landscape-up') {
    margin-bottom: 110px;
  }

  &__bg-container {
    padding: 0;

    @include breakpoint('desktop-up') {
      position: relative;
    }

    // @include breakpoint('desktop-large-up') {
    //   width: auto;
    // }
  }

  &__bg {
    position: relative;
    width: 100%;
    padding-top: 59.17%;
    // padding-top: 63.5313%;
    // padding-top: 36.4686%;
    z-index: -1;
    background-size: cover;
    background-repeat: no-repeat;
    background-size: 100%;
    background-image: url(#{$imagePath}/hero-mobile.jpg);

    @include breakpoint('tablet-portrait-up') {
      top: 0;
      padding-top: 0;
      position: absolute;
      background-image: url(#{$imagePath}/hero-desktop.jpg);
      // background-image: url(#{$imagePath}/hero-desktop-cropp ed-old.jpg);
      height: 560px;
      left: 290px;
      background-size: auto 560px;
    }

    @include breakpoint('tablet-landscape-up') {
      left: 390px;
      background-size: auto 768px;
      height: 768px;
    }

    @include breakpoint('desktop-up') {
      top: -401px;
      left: 430px;
    }

    @include breakpoint('desktop-large-up') {
      // left: 45%;
      width: 100vw;
      left: 440px;
    }
  }

  &__heading {
    margin-bottom: 0px;
    margin-top: 70px;
    text-align: center;
    line-height: 1.3;
    @include breakpoint('mobile-large-up') {
      font-size: 36px;
    }

    @include breakpoint('tablet-portrait-up') {
      text-align: left;
      margin-top: 60px;
      width: 350px;
    }

    @include breakpoint('tablet-landscape-up') {
      font-size: 50px;
      line-height: 60px;
      margin-top: 120px;
      margin-bottom: 10px;
      width: 460px;
    }
  }

  &__subheading {
    font-weight: 600;
    margin-top: 0px;
    text-align: center;

    @include breakpoint('tablet-portrait-up') {
      font-size: 17px;
      text-align: left;
      margin-bottom: 50px;
    }

    @include breakpoint('tablet-landscape-up') {
      margin-bottom: 85px;
    }

    @include breakpoint('desktop-up') {
      font-weight: 600;
      margin-bottom: 95px;
      margin-top: 5px;
    }
  }

  &__cta-text {
    font-weight: 600;
    font-size: 17px;
    line-height: 1.5;
    text-align: center;
    width: 180px;
    margin: 0 auto 20px auto;

    @include breakpoint('tablet-portrait-up') {
      margin: 0 auto 30px auto;
      text-align: left;
      margin-left: 0;
      width: 180px;
    }

    @include breakpoint('tablet-landscape-up') {
      margin: 0 0 25px 0;
      width: 100%;
    }

    @include breakpoint('desktop-up') {
      width: 355px;
    }
  }

  &__buttons {
    display: flex;

    @include breakpoint('mobile-large-up') {
      justify-content: center;
    }

    @include breakpoint('tablet-portrait-up') {
      width: 355px;
      justify-content: flex-start;
    }
  }

  &__button {
    width: 50%;
    &:first-of-type {
      margin-right: 15px;
    }

    @include breakpoint('mobile-large-up') {
      max-width: 150px;
    }

    @include breakpoint('tablet-portrait-up') {
      font-size: 19px;
      max-width: 125px;
      padding: 11px 0;
      margin-right: 15px;
    }

    @include breakpoint('tablet-landscape-up') {
      padding: 16px 0;
      max-width: 165px;
      margin-right: 25px;
      color: #A5E0FC;
      color: #DAF2FE;
    }

  }

  &__tooltip {
    margin: 15px 0;
    text-align: center;

    @include breakpoint('mobile-large-up') {
      max-width: 265px;
      margin: 20px auto;
    }

    @include breakpoint('tablet-portrait-up') {
      text-align: left;
      margin: 30px 0;
      max-width: 260px;
    }

    @include breakpoint('tablet-landscape-up') {
      max-width: 355px;
    }

    small {
      font-size: 12px;
      @include breakpoint('tablet-portrait-up') {
        font-size: 14px;
      }
    }
  }
}
</style>
